import { ErrorHandler, Injectable, Injector} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { ErrorNotificationService } from './error-notification.service';
import { SessionManagementService } from './session-management-service';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private injector: Injector) {}

  handleError(error: Error | HttpErrorResponse) {
    const notificationService = this.injector.get(ErrorNotificationService);
    const sessionService = this.injector.get(SessionManagementService);

    const router = this.injector.get(Router);

    if (error instanceof HttpErrorResponse) {
      if (!navigator.onLine) {
        notificationService.notify('No internet connection detected. Please try again after reconnecting.');
      } else if (error.status === 401) {
        console.log("seesion expired");
        // sessionService.notify('Session Expired, Please login to continue');
      }  else {
        notificationService.notify('Uh oh! Looks like something went wrong at our end. Please refresh and try again.');
      }
    } else {
      // router.navigate(['/error'], { queryParams: {error: `Application encountered an error. ${error}`} });
    }
    console.error('Global errror handler:', error);
  }

}
